import { render, staticRenderFns } from "./PatientDetail.vue?vue&type=template&id=3773292f&scoped=true"
import script from "./PatientDetail.vue?vue&type=script&lang=js"
export * from "./PatientDetail.vue?vue&type=script&lang=js"
import style0 from "./PatientDetail.vue?vue&type=style&index=0&id=3773292f&prod&lang=scss"
import style1 from "./PatientDetail.vue?vue&type=style&index=1&id=3773292f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3773292f",
  null
  
)

export default component.exports